import { loadData } from '../Storage';

const axios = require('axios');

const apiRoot = process.env.NODE_ENV === 'development'
  ? 'http://localhost:8080/api' : 'https://api.rebar.ai';


export const RemoteMixin = (superclass) => class extends superclass {
  constructor(dataID) {
    super();
    this.remoteID = dataID;
    this.loaded = false;
    this.isRemoteSeries = true;
  }
  
  loadRemoteData() {
    if (this.loaded) return;
  
    return axios.get(`${apiRoot}/data/${this.remoteID}`)
      .then((response) => {
        let body = (response.data || {});
        let timeseriesData = body.Data;

        let theData = loadData(timeseriesData);

        super.push(...theData);
        this.loaded = true;
        
        return this.loaded;
      })
      .catch(() => console.log("Error loading data"));
  }
};